import React, { useState, useEffect } from 'react';
import StaticModal from 'shared/common/modal/staticModal';
import { useHistory } from 'react-router-dom';
import { userStore } from 'store/UserStore';

// import './Redeem.css';
interface PropsType {
  modalTrue?: any;
}

const NomineeModal: React.FC<PropsType> = ({ modalTrue }) => {
  const [showModal, setShowModal] = useState(false);
  const [customer] = userStore((state: any) => [state.customer]);
  const history = useHistory();
  const redirectFunc = () => {
    history.push('/profile?nomination=true');
  };
  useEffect(() => {
    // Check if the popup has been shown before in local storage
    if (
      // customer?.isFirstBuy &&
      customer?.nomineeDetails?.length < 1 &&
      customer.customerCategory === 'UNREGISTERED' &&
      customer?.giftCount == 0
    ) {
      const hasPopupBeenShown = localStorage.getItem('popupShown');
      if (!hasPopupBeenShown) {
        setShowModal(true);
      }
    }
    // else if (customer?.nomineeDetails?.length > 0) {
    //   setShowModal(false);
    // }
  }, []);

  const closePopup = () => {
    // Mark the popup as shown in local storage
    localStorage.setItem('popupShown', 'true');
    setShowModal(false);
  };
  return (
    <div>
      {customer.customerCategory === 'UNREGISTERED' && (
        <StaticModal
          show={showModal}
          // handleClose={onKYCPopupClose}
          // title=''
          // onClose={() => {
          //   hideModal()
          // }}

          // size='lg'

          center
        >
          {/* {customer?.isFirstBuy == false ? (
            <div>
              <div className='RedeemMainDiv p-3 '>
                <p className='text-1 '>
                  {' '}
                  To proceed further, please update your nominee details in the
                  system 👇
                  <i className='fa-solid fa-hand-back-point-right'></i>
                </p>

                <button
                  className='btn btn-primary btn-lg'
                  onClick={() => redirectFunc()}
                >
                  Add Nominee
                </button>
              </div>
            </div>
          ) : ( */}
            <div>
              <div className='RedeemMainDiv p-3 '>
                <p className='text-1 text-center'>
                  {' '}
                  Do you want to update nominee details?
                  <i className='fa-solid fa-hand-back-point-right'></i>
                </p>
                {/* <br /> */}
                <div className='d-flex justify-content-center'>
                  <button
                    className='btn btn-primary m-2'
                    onClick={() => redirectFunc()}
                  >
                    Now
                  </button>
                  <button
                    className='btn btn-secondary m-2'
                    onClick={() => closePopup()}
                  >
                    Later
                  </button>
                </div>
              </div>
            </div>
          {/* )} */}
        </StaticModal>
      )}
    </div>
  );
};

export default NomineeModal;
